import { Alert, Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

interface ConfirmArchiveDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  templateName?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ConfirmArchiveDialog: React.FC<ConfirmArchiveDialogProps> = ({
  open,
  setOpen,
  onConfirm,
  onCancel,
  templateName,
}) => {
  return (
    <Dialog
      title="Archive Template"
      open={open}
      setOpen={setOpen}
      primaryButton={{
        text: "Archive",
        onClick: onConfirm,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onCancel,
      }}
      size="2xl"
    >
      <Paragraph className="mb-4" displayType="normal" colorType="primary">
        Are you sure you want to archive “{templateName}”? Archived templates will no longer be available for creating
        new reports but existing reports using this template will not be affected.
      </Paragraph>
      <Alert
        title=""
        text={<p className="-mt-2">You can restore archived templates from the archive tab.</p>}
        appearance="neutral"
      />
    </Dialog>
  );
};
